// (function () {
//     'use strict';

//     angular.module("imApp").factory("custGrpsService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listCustomerGroups: function (parms) {
//                 return $ihttp.post({
//                     method: 1005,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
